import { Flex, Text } from '@procurify/ui'

import { useProcurifyIntl } from '@webapp/hooks'
import { ConversationOrderSummarySection } from './ConversationOrderSummarySection'
import messages from './messages'
import { ConversationOrderSummaryValueStyled } from './styles/ConversationOrderSummaryValueStyled'
import { type ConversationCartAddress } from '../../value-objects/ConversationTurnItem'

export interface IConversationCheckoutOrderSummaryAddressesProps {
  shipTo?: ConversationCartAddress
  billTo?: ConversationCartAddress
}

export const ConversationCheckoutOrderSummaryAddresses = ({
  shipTo,
  billTo,
}: IConversationCheckoutOrderSummaryAddressesProps) => {
  const intl = useProcurifyIntl()

  const addresses = [
    {
      key: 'ship-to',
      label: intl.formatMessage(messages.shipTo),
      address: shipTo,
    },
    {
      key: 'bill-to',
      label: intl.formatMessage(messages.billTo),
      address: billTo,
    },
  ].filter(
    (entry): entry is typeof entry & { address: ConversationCartAddress } =>
      Boolean(entry.address)
  )

  if (addresses.length === 0) return null

  return (
    <ConversationOrderSummarySection
      ariaLabel={addresses.map(({ label }) => label).join(', ')}
      isCollapsible={false}
      title={
        <Flex.Row flexWrap='nowrap'>
          {addresses.map(({ key, label, address }) => (
            <Flex.Item key={key} flex={1}>
              <Text color='textSecondary'>{label}</Text>
              <ConversationOrderSummaryValueStyled className='fs-mask'>
                {address.name}
              </ConversationOrderSummaryValueStyled>
              {address.addressLines.map((line, index) => (
                <ConversationOrderSummaryValueStyled
                  key={index}
                  className='fs-mask'
                >
                  {line}
                </ConversationOrderSummaryValueStyled>
              ))}
            </Flex.Item>
          ))}
        </Flex.Row>
      }
    />
  )
}
